
<template>
  <div class="wrapper">
    <div class="container">
      <md-card class="customCard navbar-margin">
        <md-card-content>
          <div class="tim-typo">
            <h2 class="title">Balkongeländer &amp; Verkleidungen</h2> 
            <p>Wir bieten Ihnen eine Vielfalt an Modellen. Die Konstruktion besteht aus farbbeschichtetem Aluminium - sehr witterungsbeständig und pflegeleicht. <br>
              Sicherlich ist auch das passende Modell für Sie dabei. Nehmen Sie Kontakt mit uns auf, damit wir gemeinsam Ihre Ideen und Vorstellungen planen und ausführen können.</p>
          </div>
          <div class="gallery">
            <div class="gallery-panel"
              v-for="balkon in balkons"
              :key="balkon.id">
              <router-link :to="`/produkte/Balkon/${balkon.family}`">
                <mdb-view  class="zoom rounded hoverable z-depth-1-half" :src="thumbUrl(balkon.filename)">
                  <mdb-mask class="flex-center">
                    <p class="panel-titel"> {{balkon.caption}} </p>
                  </mdb-mask>
                </mdb-view>
              </router-link>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import balkons from '@/components/balkons.json';
import { mdbView, mdbMask } from "mdbvue";

export default {
  name: 'Gallery',
  data() {
    return {
      balkons
    };
  },
  mounted() {
    //declare the folder path to the product image folder here
    this.importAll(require.context('../assets/prod_images/Balkon/', true, /\.(jpg|png|gif)$/));
  },
  methods: {
    importAll(r) {
      r.keys().forEach(key => (this.images.push({ pathLong: r(key), pathShort: key , fileName: key.match(/[ \w-ÄäÖöÜüß]+?(?=\.)/)})));
    }, 
    thumbUrl(filename) {
      return require(`../assets/prod_images/Balkon/${filename}`);
    },
    onResponsiveInverted() {
      if (window.innerWidth < 600) {
        this.responsive = true;
      } else {

        this.responsive = false;
      }
    }
  
  },
  components: {
    mdbView,
    mdbMask
    
    
  }
};
</script>